import type { Container } from '@sbclite/core';

type StoredPolicy = Pick<Container.ProfileDetailInfo, 'role' | 'priority' | 'maxConcurrentCalls' | 'maxCps' | 'constraints'>;

// Required API metadata for new profiles; these values do not establish runtime quotas or roles.
export function preservedProfilePolicy(profile: StoredPolicy | null) {
  return {
    role: profile?.role ?? 'full',
    priority: profile?.priority ?? 100,
    maxConcurrentCalls: profile?.maxConcurrentCalls ?? 5000,
    maxCps: profile?.maxCps ?? null,
    constraints: profile?.constraints ?? null,
  } satisfies Pick<Container.ProfileCreateInput, keyof StoredPolicy>;
}
